import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { InvoiceLanguage } from "../invoiceAPI";

type Props = {
  language: InvoiceLanguage;
};

export const PreviewInvoiceLanguage = ({ language }: Props) => {
  const { t } = useTranslation("invoices");

  return language !== InvoiceLanguage.FI ? (
    <Box sx={{ backgroundColor: "#ffffff", borderRadius: "8px" }} p={1} mb={2}>
      <Typography>
        {t("invoiceWillBeSentIn", {
          language: t(`in${language}`),
        })}
      </Typography>
    </Box>
  ) : null;
};
